import InputFile from './file';


document.addEventListener('DOMContentLoaded', () => {

    const btns = document.querySelectorAll('.js-add-file');
    btns.forEach((btn, index) => {

        btn.addEventListener('click',(e)=>{
            e.preventDefault();
            let count = btn.getAttribute('data-count');
            count++;
            const placeholder = btn.getAttribute('data-placeholder');
            const name = btn.getAttribute('data-name');
            let maxsize = '';
            if(btn.getAttribute('data-max-size')){
                maxsize = 'data-max-size="'+btn.getAttribute('data-max-size')+'"';
            }
            let descr = '';
            if(btn.getAttribute('data-descr')){
                descr = '<div class="form__line__descr">'+btn.getAttribute('data-descr')+'</div>';
            }
            const required = btn.getAttribute('data-required');
            btn.setAttribute('data-count', count);
            const parent = btn.parentNode;
            parent.insertAdjacentHTML('beforebegin', '<div class="form__line">\n' +
                '<input class="js-file file-input--btn js-file-'+name+'-'+count+'" type="file" name="'+name+'-'+count+'" data-placeholder="'+placeholder+'" '+maxsize+' '+required+'>'+ descr +
                '</div>');


            new InputFile('.js-file-'+name+'-'+count);

            const btnRemove = parent.querySelector('.js-del-file');
            btnRemove?.removeAttribute('disabled');

        });

    });

    const delBtns = document.querySelectorAll('.js-del-file');
    delBtns.forEach((btn, index) => {

        btn.addEventListener('click',(e)=>{
            e.preventDefault();
            const parent = btn.parentNode;
            const btnAdd = parent.querySelector('.js-add-file');
            let count = btnAdd.getAttribute('data-count');
            if(count>1){
                count--;
                btnAdd.setAttribute('data-count', count);
                const formLine = parent.previousElementSibling;
                formLine?.remove();
            }
            if(count=="1"){
                btn.setAttribute('disabled','disabled');
            }

        });

    });

});
